import axios from 'axios';

const EVENTS_API_URL = 'https://3rey9w5wwi.execute-api.us-east-1.amazonaws.com/oryzadev/event/';
const OFFERS_API_URL = 'https://3rey9w5wwi.execute-api.us-east-1.amazonaws.com/oryzadev/offer/';
const PETTI_PETTI_HOTEL = 'Petti Petti Mirissa';

const filterActivePettiItems = (data) => {
  const items = Array.isArray(data) ? data : [];
  return items
    .filter(
      (item) => item.hotelName === PETTI_PETTI_HOTEL && item.status === 'active'
    )
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const apiService = {
  getEvents: async () => {
    try {
      let data = null;

      if (typeof window !== 'undefined' && window.__PETTI_EVENTS__) {
        data = await window.__PETTI_EVENTS__;
      }

      if (!Array.isArray(data)) {
        const response = await axios.get(EVENTS_API_URL);
        data = response.data;
      }

      return filterActivePettiItems(data);
    } catch (error) {
      console.error('Error fetching events:', error);
      return [];
    }
  },

  getOffers: async () => {
    try {
      let data = null;

      if (typeof window !== 'undefined' && window.__PETTI_OFFERS__) {
        data = await window.__PETTI_OFFERS__;
      }

      if (!Array.isArray(data)) {
        const response = await axios.get(OFFERS_API_URL);
        data = response.data;
      }

      return filterActivePettiItems(data);
    } catch (error) {
      console.error('Error fetching offers:', error);
      return [];
    }
  }
};

export default apiService;
